module.exports = __webpack_public_path__ + "static/media/QR_feishu_guangfeng.584728ad.png";